var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EditableDynamicTable, EditablePage, Link, isSufficientPermission, returnError, withAnalytics, withGraphqlErrorFlags, withLoadingSpinner, withServiceNotFoundHandler, withShowFlag, compose, graphql } from "@atlassiansox/microscopekit";
import * as React from "react";
import { Permission } from "../../__generated__/graphql-global-types";
import serviceQuery from "./service-query.query.graphql";
import updateServiceMutation from "./update-service.mutation.graphql";
var uuidv4 = require('uuid/v4');
var ERROR_FORBIDDEN = "403: Forbidden";
var DnsNamesView = /** @class */ (function (_super) {
    __extends(DnsNamesView, _super);
    function DnsNamesView(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultSource = "Other";
        _this.isEditableItem = function (dnsName) { return dnsName.source === _this.defaultSource; };
        _this.tableFields = [
            {
                key: "value",
                headContent: "Value",
                isSortable: true,
                isDefaultSortKey: true,
                defaultSortOrder: "ASC",
                isEditable: _this.isEditableItem,
                validate: function (dnsName) { return dnsName.value ? undefined : "Value is required"; }
            },
            {
                key: "source",
                headContent: "Source",
                isSortable: true,
                isEditable: function (_) { return false; },
                validate: function (dnsName) { return dnsName.source ? undefined : "Source is required"; }
            },
            {
                key: "type",
                headContent: "Type",
                isSortable: true,
                isEditable: _this.isEditableItem,
                validate: function (dnsName) { return dnsName.type ? undefined : "Type is required"; }
            }
        ];
        _this.createNewDnsName = function () { return ({
            key: uuidv4(),
            type: "",
            value: "",
            source: _this.defaultSource
        }); };
        _this.onSave = _this.onSave.bind(_this);
        return _this;
    }
    DnsNamesView.prototype.componentDidMount = function () {
        document.title = this.props.data.service.id + " | DNS Names";
    };
    DnsNamesView.prototype.componentWillUnmount = function () {
        document.title = "Microscope";
    };
    DnsNamesView.prototype.validateValue = function (dnsNames) {
        return dnsNames.some(function (dnsName) {
            return !dnsName.source ||
                !dnsName.type ||
                !dnsName.value;
        }) ? "Missing required values" : undefined;
    };
    DnsNamesView.prototype.onSave = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var id, etag, dnsNames, _a, message, graphQLErrors, errMsg, errComponent;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.props.id;
                        etag = (this.props.data.service.attributes.dnsNamesAttribute ||
                            { etag: undefined }).etag;
                        dnsNames = data.dnsNames.map(function (dnsName) { return ({
                            source: dnsName.source,
                            value: dnsName.value,
                            type: dnsName.type
                        }); });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.updateService({
                                variables: {
                                    input: {
                                        id: id,
                                        attributes: {
                                            dnsNamesAttribute: {
                                                etag: etag,
                                                // null will delete attribute record from Service Central
                                                // in case we have no DNS names
                                                value: dnsNames.length > 0 ? dnsNames : null
                                            }
                                        }
                                    }
                                }
                            })];
                    case 2:
                        _b.sent();
                        this.props.showFlag({
                            type: "success",
                            title: "Success",
                            message: "DNS Names successfully updated."
                        });
                        this.props.track("DNS Names: Update", {
                            category: "info"
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errMsg = returnError(graphQLErrors, message)[0];
                        errComponent = errMsg.includes(ERROR_FORBIDDEN) ? (React.createElement("p", null,
                            "You must be in the \"Micros Just-In-Time\" access level in",
                            " ",
                            React.createElement("a", { href: "https://ssam.prod.atl-paas.net/containers/micros-sv--" + id + "/#jit", target: "_blank", rel: "noopener noreferrer" }, "your service's SSAM container"),
                            " ",
                            "to perform this operation, see",
                            " ",
                            React.createElement("a", { href: "https://go.atlassian.com/micros-tc2-compliance", target: "_blank", rel: "noopener noreferrer" }, "go/micros-tc2-compliance"),
                            " ",
                            "for details.",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("i", null, ERROR_FORBIDDEN))) : (React.createElement("p", null, errMsg));
                        this.props.showFlag({
                            type: "error",
                            title: "Failed to update DNS names",
                            message: errComponent,
                            disableAutoDismiss: true,
                        });
                        this.props.track("DNS Names: Update failed", {
                            category: "error",
                            element: "DNS Names",
                            serviceId: id
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DnsNamesView.prototype.render = function () {
        var service = this.props.data.service;
        var tableItems = service.attributes.dnsNamesAttribute &&
            service.attributes.dnsNamesAttribute.value ?
            service.attributes.dnsNamesAttribute.value
                .map(function (dnsName, idx) { return (__assign({ key: idx.toString() }, dnsName)); }) : [];
        return (React.createElement(EditablePage, { title: "DNS Names", onSave: this.onSave, isEditable: isSufficientPermission(service.currentUserPermission, Permission.Write) },
            React.createElement("div", null,
                "In the table below you can find read only list of DNS Names provisioned by ",
                React.createElement(Link, { to: "https://hello.atlassian.net/wiki/x/1nn3CQ" }, "Micros"),
                " (more sources to come in the future). In case there are some DNS Names provisioned outside Micros they can be managed by service's team members."),
            React.createElement("br", null),
            React.createElement(EditableDynamicTable, { name: "dnsNames", fields: this.tableFields, defaultValue: tableItems, createNewItem: this.createNewDnsName, allowDelete: this.isEditableItem, emptyView: React.createElement("div", null, "There are no DNS Names"), validateValue: this.validateValue })));
    };
    return DnsNamesView;
}(React.Component));
export { DnsNamesView };
// Use the `compose` function to wrap decorators around your component.
// These will run before your component code does.
export var DnsNamesPage = compose(graphql(serviceQuery, {}), graphql(updateServiceMutation, {
    name: "updateService"
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withAnalytics)(DnsNamesView);
